// Exports
export default {
	"unsupportedBrowser": "unsupportedBrowser_phT7F",
	"image": "image_NrKt7",
	"yabroLink": "yabroLink_45KMc"
};
